import React from 'react';
import BranchPicker from './BranchPicker';
import DashboardMenu from './DashboardMenu';
import { MenuIcon } from './product_item_components/icons';

function MainPageHeader({
  branches = [],
  selectedBranchName,
  isBranchPickerDisabled = false,
  onSelectBranchName,
}) {
  const [menuOpen, setMenuOpen] = React.useState(false);

  return (
    <header className="main-page-header">
      <div className="main-page-headerRow">
        <div className="main-page-headerGrow">
          <BranchPicker
            placeholder="Все филиалы"
            branches={branches}
            selectedBranchName={selectedBranchName}
            onSelectBranchName={onSelectBranchName}
            disabled={isBranchPickerDisabled}
            hideLabel
          />
        </div>

        <div className="main-page-headerActions">
          <button
            type="button"
            className="main-page-iconButton main-page-iconButton--lg"
            onClick={() => setMenuOpen(true)}
            aria-label="Меню"
            title="Меню"
            aria-expanded={menuOpen}
            aria-haspopup="dialog"
          >
            <MenuIcon />
          </button>
        </div>
      </div>

      <DashboardMenu
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        branches={branches}
      />
    </header>
  );
}

export default MainPageHeader;
